var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"toast"}},[_c('span',{staticClass:"loading",style:({ top: _vm.styleTop })},[_c('div',{staticClass:"loading-spinner"}),_c('div',[_vm._v("加载中...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }